module.exports = __webpack_public_path__ + "img/form-logo.14c9cdf0.png";